import React, { FunctionComponent } from 'react';

/**
 * Add Icon.
 */
const AddIcon: FunctionComponent<
  React.PropsWithChildren<{
    className?: string;
    color?: string;
    width?: string;
    height?: string;
  }>
> = ({ className, color = 'white', width = '11', height = '12' }) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 11 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.1668 5.66671H6.16683V9.66671H4.8335V5.66671H0.833496V4.33337H4.8335V0.333374H6.16683V4.33337H10.1668V5.66671Z"
        fill={color}
      />
    </svg>
  );
};

export default AddIcon;
